import { CLIENT } from './config'

export const MAINTENANCE = {
  HEALTHCHECK: '/version',
}

export const healthCheck = async (): Promise<void> => {
  await CLIENT.get<void>(MAINTENANCE.HEALTHCHECK)
}
